'use client';

import { useEffect } from 'react';
import { trackViewItem } from '@/lib/analytics/ga4';
import { fbTrackViewContent } from '@/lib/analytics/fbpixel';

interface Props {
  product: {
    product_id: number;
    name: string;
    slug?: string;
    category_name?: string;
    base_price?: number | string;
  };
}

export default function PdpTracking({ product }: Props) {
  useEffect(() => {
    // GA4 view_item + Meta ViewContent; neither can break the page.
    try { trackViewItem(product); } catch { /* tracking is optional */ }
    try {
      fbTrackViewContent({
        id: product.product_id,
        name: product.name || '',
        category: product.category_name,
        // base_price here is the real starting quote passed by the page
        price: Number(product.base_price) || undefined,
      });
    } catch { /* tracking is optional */ }
  }, [product.product_id]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
